import { ChevronUp } from 'lucide-react';

interface PlpScrollToTopButtonProps {
  show: boolean;
}

export function PlpScrollToTopButton({ show }: PlpScrollToTopButtonProps) {
  return (
    <button
      type="button"
      aria-label="Go to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={[
        'fixed top-1/2 right-0 -translate-y-1/2 z-50 hidden md:flex items-center justify-center w-8 h-12 rounded-tl-sm rounded-bl-sm bg-[#E84C3D] text-white shadow-lg hover:bg-[#c73d30] transition-[opacity,colors] duration-300',
        show ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
      ].join(' ')}
      aria-hidden={!show}
    >
      <span className="flex flex-col items-center leading-none gap-0.5">
        <ChevronUp className="w-4 h-4" aria-hidden />
        <span className="text-[9px] font-bold uppercase">Top</span>
      </span>
    </button>
  );
}
